import i18next from "i18next";

const chargebeeCreateSessionApiPath = "/ecomm/api/bff/customer-portal/sessions";
const chargebeeLibraryUrl = "https://js.chargebee.com/v2/chargebee.js";

export function showChargeBeeUi(inertiaProps) {
    const isChargebeeEnabled = Boolean(
        inertiaProps.auth.current_organization.is_owner &&
            inertiaProps.features["ecomm"]
    );

    if (isChargebeeEnabled && !isScriptLoaded(chargebeeLibraryUrl)) {
        loadScript(chargebeeLibraryUrl);
    }

    return isChargebeeEnabled;
}

export function getChargeBeeInstance(inertiaProps) {
    if (!window.Chargebee) return null; //==>

    try {
        return window.Chargebee.getInstance(); //==>
    } catch (e) {
        return window.Chargebee.init({
            site: inertiaProps.ecommerce.embed_site,
        }); //==>
    }
}

export async function showChargebeeSection(inertiaProps, section) {
    const chargeBeeInstance = getChargeBeeInstance(inertiaProps);

    if (!chargeBeeInstance) return; //==>

    try {
        const chargebeeSession = await axios.post(
            chargebeeCreateSessionApiPath
        );

        chargeBeeInstance.setPortalSession(chargebeeSession.data);

        chargeBeeInstance.createChargebeePortal().openSection({
            sectionType: Chargebee.getPortalSections()[section],
            params: {
                subscriptionId: chargebeeSession.data.subscription_id,
            },
        });
    } catch (error) {
        throw new Error(i18next.t("chargebee.create-session-error"));
    }
}

function loadScript(url, callback) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;

    script.onload = () => {
        if (callback) {
            callback();
        }
    };

    script.onerror = (error) => {
        console.error(`Error loading script "${url}":`, error);
    };

    document.head.appendChild(script);
}

function isScriptLoaded(url) {
    const scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src === url) {
            return true;
        }
    }
    return false;
}
